<div class="not-accepting-clients" data-test="not-accepting-clients">
  <p class="heavy">Call <a href="tel:{{ bookSessionPhoneLink }}">{{ bookSessionPhoneDisplay }}</a> to book a session.</p>
  <p>Our Care Coordinators will guide you through the process.</p>
</div>